<div class="chat-page">
  <div class="chat-page__header">
    <button
      *ngIf="selectedChatId && !showFullPage"
      tuiIconButton
      class="chat-page__return-button"
      type="button"
      appearance="icon"
      iconStart="@tui.arrow-left"
      size="s"
      [tuiHint]="'common.buttons.return' | translate"
      (click)="onClickReturnButton()"
    ></button>
    <ng-container *ngIf="showFullPage">
      <h1 class="chat-page__title">{{ 'components.navigation.constants.navigationItems.chatsTitle' | translate }}</h1>

      <app-actions [mode]="'menu'" [items]="createMenuItems">
        <button
          tuiIconButton
          class="button button_add"
          type="button"
          appearance="icon"
          iconStart="@tui.circle-plus"
          size="s"
        ></button>
      </app-actions>

      <app-settings-button class="chat-page__settings-button"></app-settings-button>
    </ng-container>
  </div>

  <div [hide]="!showFullPage" class="chat-page__list">
    <div class="header">
      <app-search [(searchQuery)]="searchQuery" (searchQueryChange)="searchQueryChangeHandler($event)"></app-search>
    </div>

    <tui-scrollbar>
      <app-chats-list
        [items]="searchChats ? searchChats : chats"
        [(selectedId)]="selectedChatId"
        (selectedIdChange)="onChangeSelectedChatId($event)"
      ></app-chats-list>
    </tui-scrollbar>
  </div>

  <div *ngIf="!!selectedChatId" class="chat-page__content">
    <app-chat [chatId]="selectedChatId"></app-chat>
  </div>
</div>
